import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Typography,
  message,
  Space,
  Card,
} from 'antd'
import { ROW_JUSTIFY, COL_SPAN, AvatarColorsArr } from '../common/const'
import {
  UrlQueryParamsParse,
  loginClient,
  getTeamAvatarStr,
  addUrlParam,
  openRedirectUrl,
  handleResponse,
} from '../common/globalFun'
import API from '../config/api'
import errCode, { GetErrMsg } from '../config/errCode'
import { useIntl } from 'react-intl'

import './css/style.css'

import iconArrowRight from '../res/img/arrow_right.png'
import iconActive from '../res/img/right.png'

const { Title } = Typography

const LOCALSTORAGE_KEY_LAST_CORP = 'last_open_corp'

const SelectCorp = (props) => {
  const { history } = props
  const intl = useIntl()

  const [token, setToken] = useState('') // IdentifyToken
  const [teamList, setTeamList] = useState([])
  const [isInit, setIsInit] = useState(false)
  const [account, setAccount] = useState('')

  const getUrlToken = () => {
    const { search } = props.location
    const urlQuertParamsStr = search.replace(/^\?/, '')
    const queryParamsData = UrlQueryParamsParse(urlQuertParamsStr)
    if (queryParamsData && queryParamsData.token) {
      const iDentifytoken = decodeURIComponent(queryParamsData.token)
      setToken(iDentifytoken)
    }
  }

  const saveLastOpenTeam = (teamId) => {
    const lastCorp = localStorage.getItem(LOCALSTORAGE_KEY_LAST_CORP)
    if (!lastCorp) {
      localStorage.setItem(LOCALSTORAGE_KEY_LAST_CORP, teamId)
    } else if (lastCorp.indexOf(teamId) === -1) {
      let lastCorpArr = lastCorp.split(',')
      lastCorpArr.unshift(teamId)
      lastCorpArr = lastCorpArr.slice(0, 10)
      const newLastCorp = lastCorpArr.join(',')
      localStorage.setItem(LOCALSTORAGE_KEY_LAST_CORP, newLastCorp)
    }
  }

  const sortTeamListByLastOpen = (teamList) => {
    const lastCorp = localStorage.getItem(LOCALSTORAGE_KEY_LAST_CORP)
    if (!lastCorp) {
      return teamList
    }

    let sortTeamListFront = []
    const lastCorpArr = lastCorp.split(',')
    lastCorpArr.reverse()
    lastCorpArr.map((teamId) => {
      let teamIndex = teamList.findIndex((team) => team.teamId == teamId)
      if (teamIndex != -1) {
        sortTeamListFront.push(teamList[teamIndex])
      }
    })

    let sortTeamListBehind = teamList.filter((item) => {
      return (
        sortTeamListFront.findIndex(
          (frontItem) => frontItem.teamId == item.teamId
        ) === -1
      )
    })
    return sortTeamListFront.concat(sortTeamListBehind)
  }

  const translateTeamList = (teamList) => {
    let newTeamList = []
    teamList = sortTeamListByLastOpen(teamList)
    teamList.forEach((item) => {
      let avatarColor = AvatarColorsArr[item.teamId % AvatarColorsArr.length]
      let obj = Object.assign(item, {
        avatarColor: avatarColor,
      })
      if (!!item.isCurrent) {
        newTeamList.unshift(obj)
      } else {
        newTeamList.push(obj)
      }
    })
    return newTeamList
  }

  const switchOrg = (item) => {
    if (item.isCurrent) {
      return
    }
    saveLastOpenTeam(item.teamId)
    getLoginKey(item.teamId)
  }

  useEffect(() => {
    getUrlToken()
  }, [])

  useEffect(() => {
    if (token) {
      getToken(token)
    }
  }, [token])

  useEffect(() => {
    if (props.token) {
      getTeamList()
    }
  }, [props.token])

  /**
   * 请求相关
   */

  const getTeamList = () => {
    const url = API.GET_TEAM_LIST
    fetch(url, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        timestamp: new Date().getTime().toString(),
        token: props.token,
      }),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.errCode === errCode.OK) {
          setIsInit(true)
          const { teamList } = rsp
          if (teamList && teamList.length) {
            let newTeamList = translateTeamList(teamList)
            setTeamList(newTeamList)
          }
        } else {
          message.error(GetErrMsg(rsp.errCode))
        }
      })
      .catch((error) => {
        message.error(JSON.stringify(error))
      })
  }

  const getLoginKey = (teamId) => {
    const url = API.GET_LOGIN_KEY
    const param = {
      teamId: teamId,
    }

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(param),
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        timestamp: new Date().getTime().toString(),
        token: props.token,
      }),
    })
      .then(handleResponse)
      .then((rsp) => {
        if (rsp.errCode === errCode.OK) {
          const { loginKey } = rsp
          if (props.redirectUri) {
            const newHref = addUrlParam(props.redirectUri, {
              loginKey: loginKey,
            })
            openRedirectUrl(newHref)
          } else {
            loginClient(loginKey)
          }
        } else {
          if (rsp.errCode) {
            message.error(GetErrMsg(rsp.errCode))
          } else {
            message.error(rsp)
          }
        }
      })
      .catch((error) => {
        message.error(JSON.stringify(error))
      })
  }

  // 身份验证token 转成 JWT token
  const getToken = (token) => {
    const url = API.GET_TOKEN
    fetch(url, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        timestamp: new Date().getTime().toString(),
        token: token,
      }),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.errCode === errCode.OK) {
          const { token, userInfo } = rsp
          props.setGlobalToken(token)
          if (userInfo && userInfo.account) {
            setAccount(userInfo.account)
          }
        } else {
          message.error(GetErrMsg(rsp.errCode))
        }
      })
      .catch((error) => {
        message.error(JSON.stringify(error))
      })
  }

  return (
    <Row
      justify={ROW_JUSTIFY}
      align="middle"
      className={`height-full select-corp-page`}
    >
      <Col span={COL_SPAN}>
        <Title level={3} className="no-margin-top content-center">
          {intl.formatMessage({ id: 'select.org.signin' })}
        </Title>
        <Space direction="vertical" size={15} className="mt-10 card-list-wrap">
          {!!teamList.length &&
            teamList.map((item, index) => {
              return (
                <Card
                  key={index}
                  hoverable={!item.isCurrent}
                  size="small"
                  onClick={() => {
                    switchOrg(item)
                  }}
                  className={`card-box`}
                >
                  <Row wrap={false} className="card-wrap">
                    <Col flex="auto">
                      <Row wrap={false}>
                        <Col>
                          <div
                            className={`card-avatar-wrap ${
                              item.isCurrent ? 'active' : ''
                            }`}
                          >
                            <div
                              className="card-avatar"
                              style={{
                                backgroundColor: item.avatarColor
                                  ? item.avatarColor
                                  : '#616061',
                              }}
                            >
                              {getTeamAvatarStr(item.teamName)}
                            </div>
                          </div>
                        </Col>
                        <Col
                          className="card-name overflow"
                          title={item.teamName}
                        >
                          <span className="text">{item.teamName}</span>
                        </Col>
                      </Row>
                    </Col>
                    <Col flex="none" className={`card-icon-wrap`}>
                      {item.isCurrent ? (
                        <img
                          className="card-icon-active"
                          src={iconActive}
                          alt=""
                        />
                      ) : (
                        <img
                          className="card-icon-arrow"
                          src={iconArrowRight}
                          alt=""
                        />
                      )}
                    </Col>
                  </Row>
                </Card>
              )
            })}
          {isInit && !teamList.length && (
            <section>
              <p>{intl.formatMessage({ id: 'not.org' })}</p>
              <p>{account}</p>
            </section>
          )}
          {!isInit && (
            <Card hoverable size="small" loading className="card-wrap" />
          )}
        </Space>
      </Col>
    </Row>
  )
}

const stateProps = (state) => {
  return {
    token: state.token,
    redirectUri: decodeURIComponent(state.redirectUri),
  }
}

const dispatchProps = (dispatch) => ({
  setGlobalToken: (token) => {
    dispatch({
      type: 'setToken',
      value: token,
    })
  },
})

export default connect(stateProps, dispatchProps)(SelectCorp)
